module.exports = __webpack_public_path__ + "img/bj2.add4897e.png";